import * as Parse from 'parse';
import * as React from 'react';
import { SignInViewModel } from '../../viewmodels';
import { Controllers } from '../abstract';
import View from './SignInView';

interface IAuthorizationControllerState {
    model: SignInViewModel,
    logicError: string
}

class AuthorizationController<P extends Interfaces.IViewControllerProps> extends Controllers.ViewController<P, IAuthorizationControllerState> {

    constructor(props: P) {
        super(props);
        this.state = {
            logicError: '',            
            model: new SignInViewModel()
        }
    }

    public async signIn() {
        const { model } = this.state;
        let successAuth = null;
        this.setState({loading:true})
        try {
            successAuth = await Parse.User.logIn(model.login, model.password);
        } catch (e) {
            this.setState({ loading:false, logicError: e.message });
        }
        if (successAuth) {
            // const currentUser = Parse.User.current();
            // const ACL = currentUser!.getACL();
            this.setState({ loading:false, logicError: 'У вас нет прав для входа!' });
            // if(ACL!.permissionsById['role:admin']){
            //     this.props.history['push']('/');    
            // } else {
            //     await Parse.User.logOut();
            //     // this.props.history['push']('/');    
            //     this.setState({ loading:false, logicError: 'У вас нет прав для входа!' });
            // }
        }
    }

    public telem_render(): JSX.Element {
        const {logicError, model, loading} = this.state;
        return (
            <View
                loading={loading}
                model={model}
                logicError={logicError}
                // tslint:disable-next-line:jsx-no-lambda
                signIn={() => this.signIn()}
            />
        );
    }
}

export default AuthorizationController;



// WEBPACK FOOTER //
// ./src/app/authorization/AuthorizationController.tsx